import { Alert, Button, Modal, Table, Typography } from "antd"
import { useJobCopiesQuery } from "./jobsQueries"
import { JobCopy } from "./jobsApi"
import VSpace from "../common/VSpace"

type Props = {
  isOpen: boolean
  onClose: () => void
  jobId: number
}

const JobCopiesModal = ({isOpen, onClose, jobId}: Props) => {
  const jobCopiesQuery = useJobCopiesQuery(jobId, isOpen)
  const areAnyDeleted = jobCopiesQuery.data?.some(x => x.isJobDeleted) ?? false

  return <Modal
    width={1000}
    title="Job Copy History"
    open={isOpen}
    onCancel={onClose}
    footer={<Button onClick={onClose}>Close</Button>}
  >
    <VSpace>
      <Table
        size="small"
        dataSource={jobCopiesQuery.data}
        rowKey={x => x.id}
        loading={jobCopiesQuery.isLoading}
        columns={[
          {title: 'Copied', render: (_, x) => new Date(x.updatedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })},
          {title: 'Job', dataIndex: 'jobName'},
          {title: 'No', render: (_, x) => {
            if (!x.isJobDeleted && x.jobUrl) {
              return <Typography.Link>{x.jobNo}</Typography.Link>
            }
            return x.jobNo
          }},
          {title: 'Customer', dataIndex: 'customerDisplayName'},
          {title: 'Property', render: (_, x) => getPropertyDisplay(x)},
        ]}
        pagination={{
          pageSize: 10,
          hideOnSinglePage: true
        }}
        locale={{emptyText: 'This job has not been copied.'}}
        onRow={(record) => {
          const canClick = !record.isJobDeleted && record.jobUrl
          return {
            onClick: () => {
              if (canClick) {
                window.open(`#!/${record.jobUrl}`, '_blank')
              }
              
            },
            style: {
              cursor: canClick ? 'pointer' : 'not-allowed',
              textDecoration: record.isJobDeleted ? 'line-through' : undefined,
              color: record.isJobDeleted ? 'gray' : undefined,
              fontStyle: record.isJobDeleted ? 'italic' : undefined
            }
          }
        }}
      />
      {areAnyDeleted && <Alert
        message={<span>Copied jobs which have been deleted are displayed with <span style={{textDecoration: 'line-through'}}>strikethrough text.</span></span>}
        type="info"
        showIcon
      />}
    </VSpace>
  </Modal>
}

export default JobCopiesModal

const getPropertyDisplay = (x: JobCopy) => {
  if (x.propertyNickname && x.address1) {
    return `${x.propertyNickname}, ${x.address1}`
  }

  if (x.propertyNickname) {
    return x.propertyNickname
  }

  if (x.address1) {
    return x.address1
  }

  if (x.city || x.state) {
    return `${x.city} ${x.state}`.trim()
  }

  return '(No Address)'
}